import { Box, Button, Drawer, DrawerContent, DrawerHeader, DrawerOverlay } from '@chakra-ui/react';

import { FieldView, Txt } from '@app/components/common';
import { MasterOutlet } from '@app/api/models';

import { FrequencyVisitsView } from '../../new-outlets/frequency-visit-view';

export const OutletDrawer = ({ open, canEdit, onClose, outlet, onEditClick }: {
  open: boolean,
  canEdit?: boolean,
  onClose(): void,
  outlet: MasterOutlet | undefined
  onEditClick(): void
}) => {
  return <Drawer onClose={onClose} isOpen={open} placement='right'>
    <DrawerOverlay />
    <DrawerContent minW={550}>
      <DrawerHeader borderBottomWidth='1px'>{outlet?.name || outlet?.legal_name}</DrawerHeader>
      <Box px={6} py={2} overflowY='auto'>
        <FieldView title="ID" value={outlet?.id} direction="row" fullWidth canCopy />
        <FieldView title="ИНН" value={outlet?.inn} direction="row" fullWidth canCopy />
        <FieldView title='Юр. наименование' value={outlet?.legal_name} direction="row" fullWidth canCopy />
        <FieldView title="Сеть" value={outlet?.subnet} direction="row" fullWidth /> 
        <FieldView title="Вывеска" value={outlet?.title} direction="row" fullWidth />  
        <FieldView title="Статус" value={outlet?.status?.name} direction="row" fullWidth />
        <FieldView title="Дивизион" value={outlet?.division?.name} direction="row" fullWidth />
        <FieldView title="Регион" value={outlet?.region?.name} direction="row" fullWidth />
        <FieldView title="Город" value={(outlet?.city || { name: undefined })?.name} direction="row" fullWidth />
        <FieldView title="Факт. адрес" value={outlet?.address?.full_address} />
        <FieldView title="Юр. адрес" value={outlet?.legal_address} /> 
        <FieldView title="Канал" value={outlet?.channel?.name} direction="row" fullWidth />
        <FieldView title="Подканал" value={outlet?.sub_channel?.name} direction="row" fullWidth />
        <FieldView title="Сегмент" value={outlet?.segment?.name} direction="row" fullWidth />
        <FieldView title="Маршрут" value={outlet?.route_number?.name} direction="row" fullWidth />
        {outlet?.visits_day && <Box mb={2} mt={1}>
          <Txt size='sm' color='gray.500'>Дни посещения ТТ</Txt>
          <FrequencyVisitsView value={outlet?.visits_day} />
        </Box>}

        <FieldView title="Создатель" value={outlet?.acb_user?.full_name} direction="row" fullWidth />
        <FieldView title="Координатор" value={outlet?.master_user?.full_name} direction="row" fullWidth /> 

        <FieldView title="Директор" value={outlet?.director} direction="row" fullWidth />
        <FieldView title="Телефон" value={outlet?.phone} direction="row" fullWidth />
        <FieldView title="Отсрочка платежа" value={outlet?.payment_deferment} direction="row" fullWidth />

        <FieldView title="Количество холодильников" value={outlet?.count_equipment} direction="row" fullWidth />
        <FieldView title="Количество стоек" value={outlet?.count_stand} direction="row" fullWidth />
        <FieldView title="Комментарий" value={outlet?.comment} direction="column" />
        <Box mb={2} mt={6} display='flex' justifyContent='space-between'>
          {canEdit && <Button colorScheme='brand' size='md' onClick={onEditClick}>
            Редактировать
          </Button>}
          <Button  size='md' onClick={onClose}>
            Закрыть
          </Button>
        </Box>
      </Box>
    </DrawerContent>
  </Drawer>;
};